<template>
  <base-modal
    :title="'Transfer ownership'"
    :width="500"
    @closeModal="onCloseModal"
  >
    <div class="wrapper" :style="cssVars">
      <div v-html="content" />
      <div class="buttons">
        <div class="button confirm" @click="onConfirm">
          {{ confirmButton.text }}
        </div>
        <div class="button cancel" @click="onCloseModal">
          {{ cancelButton.text }}
        </div>
      </div>
    </div>
  </base-modal>
</template>

<script>
import { mapActions } from 'vuex';
import BaseModal from './BaseModal.vue';

export default {
  components: {
    BaseModal,
  },

  props: {
    // The content to display in the confirmation modal in html
    content: {
      type: String,
      default: null,
    },
    // The confirm button text and styles
    confirmButton: {
      type: Object,
      default: () => ({
        text: 'Confirm',
        color: '#fff',
        hoverColor: '#fff',
        textColor: '#fff',
      }),
    },
    // The cancel button text and styles
    cancelButton: {
      type: Object,
      default: () => ({
        text: 'Cancel',
        color: '#fff',
        hoverColor: '#fff',
        textColor: '#fff',
      }),
    },
    action: {
      type: Function,
      default: () => {},
    },
    params: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    cssVars() {
      return {
        // Css variables for confirmation button
        '--confirm-color': this.confirmButton.color,
        '--confirm-hover-color': this.confirmButton.hoverColor,
        '--confirm-text-color': this.confirmButton.textColor,
        // Css variables for cancel button
        '--cancel-color': this.cancelButton.color,
        '--cancel-hover-color': this.cancelButton.hoverColor,
        '--cancel-text-color': this.cancelButton.textColor,
      };
    },
  },

  methods: {
    ...mapActions('application/modals', ['setConfirmationModal']),

    /**
     * Event hanlder: The user presses the confirm button
     */
    onConfirm() {
      console.log(
        'onConfirm, executing action',
        this.action,
        'with params:',
        this.params
      );
      // Call the action that we need on confirmation
      this.action(...this.params);
      this.setConfirmationModal({ value: null });
    },

    /**
     * Event handler: The user presses the close button or the cancel button
     */
    onCloseModal() {
      this.setConfirmationModal({ value: null });
    },
  },
};
</script>

<style scoped lang="scss">
.wrapper {
  padding: 20px;
}

p {
  font-size: 15px;
  line-height: 1.5;
  b {
    color: #fff;
  }
}

.buttons {
  display: flex;
  justify-content: flex-end;
  .button {
    padding: 8px 12px;
    border-radius: 3px;
    display: inline-block;
    color: #fff;
    cursor: pointer;
    margin: 25px 0 0 20px;
    font-size: 15px;

    &.confirm {
      background: var(--confirm-color);
      border: none;

      &:hover {
        background: var(--confirm-hover-color);
      }
    }

    &.cancel {
      border: 1px solid #6e797b;
      background: #2c3233;

      &:hover {
        background: #464b4c;
      }
    }
  }
}
</style>
